import { render, staticRenderFns } from "./registerWd.vue?vue&type=template&id=454ee315&scoped=true"
import script from "./registerWd.vue?vue&type=script&lang=js"
export * from "./registerWd.vue?vue&type=script&lang=js"
import style0 from "./registerWd.vue?vue&type=style&index=0&id=454ee315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ee315",
  null
  
)

export default component.exports